module.exports = __webpack_public_path__ + "static/img/mobile-web-bg@t.fab004e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/haevichi/mobile-web-bg@t.jpg
// module id = lRA6
// module chunks = 0